//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import parse from 'html-react-parser';
// import Container from 'react-bootstrap/Container'
// import Row from 'react-bootstrap/Row'
// import Col from 'react-bootstrap/Col'
//@end

//@import components
// import HeaderCourseModuleSkeleton from 'app_components/modules/academic/headercourse/components/headerCourseModuleSkeleton';
// import StarsComponentCommon from 'app_components/commons/stars'
//@end

// @import hooks
// @end

// @INFO Import types
import { FORMATION_TYPE_TRANSLATIONS, ICourse } from 'app_types/campus/academic/courseTypes'
// @end

// @INFO Import services
import EditorjsService from 'app_services/components/editorjs/editorjsService';
import DurationFieldService from 'app_services/components/durationFieldService'
// @end

// @INFO Import Styles
import './../headercourseModule.scss'
import TextComponent from 'app_components/commons/TextComponent/TextComponent';

// @ADD Component types
interface IHeadercourseModuleLayoutProps {
  type: string
  course: ICourse | null
}

const HeadercourseModuleLayout: React.FC<IHeadercourseModuleLayoutProps> = (props) => {

  const durationFieldService: DurationFieldService = new DurationFieldService()
  const { t } = useTranslation()
  const { type } = props
  const editorjsService = new EditorjsService()

  return(
    <div
      className={'course-banner'}
    >
    	<div className={'Atomtextodesplegable'}>
    		<h2 className={'titulo'}> { ( type !== 'mooc' ? 'Tienda / Cursos' : 'MOOC' ) } </h2>
    	</div>
      <div className={'content-course'}>
        <h1 className={'titulo'}>{props.course?.program?.name}</h1>
        {props.course?.extra_info?.is_alternative_title_active && (
          <TextComponent type="subtitle" style={{ color: 'white' }}>{props.course?.extra_info?.alternative_title}</TextComponent>
        )}
        {props.course?.duration && (
          <p className="duration">Duración: {durationFieldService.getDurationFormated(props.course?.duration, 'large')}</p>
        )}
        {props.course?.slug_type === 'program' && props.course?.extra_info?.duration ? (
          <p className="duration">Duración: {props.course?.extra_info?.duration}</p>
        ): null}
        {props.course?.extra_info?.formationType && (
          <p className="duration">Tipo de formación: {FORMATION_TYPE_TRANSLATIONS[props.course?.extra_info?.formationType]}</p>
        )}
        <p className={'long-description'} >
          {props.course?.extra_info?.description?.blocks ? (
            parse(editorjsService.jsonToHtml(props.course?.extra_info?.description?.blocks ? props.course?.extra_info?.description?.blocks : []))
          ): (
            props.course?.extra_info?.description
          ) }
        </p>
      </div>
    </div>
  )
}

export default HeadercourseModuleLayout
